import { BotElement } from '../types/model-types';
import { Message } from './message';

export type RendererType = {new(): Renderer};

export abstract class Renderer {
    abstract render(element: BotElement, context: object): Message;
    public static readonly rendererClasses: { [s: string]: RendererType } = {};

    static register(type: string) {
        return function (rendererClass: RendererType) {
            Renderer.rendererClasses[type] = rendererClass;
        }
    }
}
